/* eslint-disable @nrwl/nx/enforce-module-boundaries */
import { observer } from 'mobx-react';
import { SelectField, TextField, CurrencyField, DateField } from '@roc/ui';
import { Grid } from '@material-ui/core';
import { useRequestExtensionForm } from '@roc/feature-loan-details';
import { isValid } from 'date-fns';

export const RequestExtensionForm = observer(() => {
  const { requestExtensionStore } = useRequestExtensionForm();

  const extensionDurationOptions = [
    { label: '3 months', value: '3' },
    { label: '6 months', value: '6' },
    { label: 'Custom', value: 'custom' }
  ];

  const preferredInsuranceOptions = [
    { label: 'ElmSure', value: 'ElmSure' },
    { label: 'Other', value: 'Other' },
  ];

  const totalLoanAmount = parseFloat(requestExtensionStore.totalLoanAmount?.replace(/[^0-9.]/g, '') || '0');
  const maxAllowed = totalLoanAmount * 0.1;
  const currentFee = parseFloat(requestExtensionStore.totalExtensionFee?.replace(/[^0-9.]/g, '') || '0');
  const isFeeTooHigh = currentFee > maxAllowed && maxAllowed > 0;

  const manageDate = (fieldName: string, value: any) => {
    // Handles both Date and event types
    if (isValid(value)) {
      console.log('Valid date selected:', value);
      requestExtensionStore.setField(fieldName, value);
    }
  };

  return (
    <Grid container spacing={2}>
      <Grid item xs={12} sm={6}>
        <TextField
          disabled
          fullWidth
          standaloneLabel
          variant="outlined"
          label='Request Date'
          testId={'requestDate'}
          value={requestExtensionStore.requestDate}
        />
      </Grid>
      <Grid item xs={12} sm={6}>
        <TextField
          disabled
          fullWidth
          standaloneLabel
          variant="outlined"
          testId={'existingMaturityDate'}
          label='Existing Maturity Date'
          value={requestExtensionStore.existingMaturityDate}
        />
      </Grid>
      <Grid item xs={12} sm={6}>
        <SelectField
          required
          fullWidth
          standaloneLabel
          variant="outlined"
          label='Extension (Duration)'
          testId={'extensionDuration'}
          options={extensionDurationOptions}
          value={requestExtensionStore.extensionDuration}
          onChange={(value) => requestExtensionStore.setField('extensionDuration', value)}
        />
      </Grid>
      <Grid item xs={12} sm={6}>
        <DateField
          format="MM/dd/yyyy"
          testId="newMaturityDate"
          required
          standaloneLabel
          inputVariant="outlined"
          label="New Maturity Date"
          value={requestExtensionStore.newMaturityDate}
          onChange={(value) => manageDate('customNewMaturityDate', value)}
          disableFuture={false}
          fullWidth
          disabled={requestExtensionStore.disableNewMaturityDate}
        />
      </Grid>
      <Grid item xs={12} sm={6}>
        <CurrencyField
          required
          fullWidth
          standaloneLabel
          variant="outlined"
          error={isFeeTooHigh}
          name='totalExtensionFee'
          label='Total Extension Fee'
          testId={'totalExtensionFee'}
          value={requestExtensionStore.totalExtensionFee}
          onChange={(_, value) => {
            requestExtensionStore.setField('totalExtensionFee', value.toString());
          }}
          errorText={isFeeTooHigh && 'The extension fee cannot exceed 10% of the total loan amount.'}
        />
      </Grid>
      <Grid item xs={12} sm={6}>
        <CurrencyField
          disabled
          fullWidth
          standaloneLabel
          variant="outlined"
          name='totalLoanAmount'
          label='Total Loan Amount'
          testId={'totalLoanAmount'}
          value={requestExtensionStore.totalLoanAmount}
        />
      </Grid>
      <Grid item xs={12}>
        <SelectField
          required
          fullWidth
          standaloneLabel
          variant="outlined"
          testId={'preferredInsurance'}
          label='Preferred Insurance Company'
          options={preferredInsuranceOptions}
          value={requestExtensionStore.extensionInsurance}
          onChange={(value) => requestExtensionStore.setField('extensionInsurance', value)}
        />
      </Grid>
      <Grid item xs={12}>
        <TextField
          fullWidth
          multiline
          minRows={4}
          label='Notes'
          standaloneLabel
          testId={'notes'}
          variant="outlined"
          value={requestExtensionStore.notes}
          onChange={(e) => requestExtensionStore.setField('notes', e.target.value)}
        />
      </Grid>
    </Grid>
  );
});
